import { render, staticRenderFns } from "./LayoutBase.vue?vue&type=template&id=8cc9638a"
import script from "./LayoutBase.vue?vue&type=script&lang=js"
export * from "./LayoutBase.vue?vue&type=script&lang=js"
import style0 from "./LayoutBase.vue?vue&type=style&index=0&id=8cc9638a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports